.cal-week {
  border-collapse: collapse;
}

.cal-week-top {
  font-weight: 400;
  text-align: left;
  color: var(--button-text);
  padding: 2px;
  text-transform: uppercase;
  white-space: nowrap;
}

.cal-week-day {
  width: 14%;
}

.cal-week-day-link:hover {
  cursor: pointer;
  text-decoration: underline;
}

.cal-week-weeksel {
  border-top: solid 1px var(--calendar-border);
  border-bottom: solid 1px var(--calendar-border);
}

.cal-week-weeksel div {
  width: 16px;
}

.cal-week-weeksel:hover {
  cursor: pointer;
  background-color: var(--hover-light);
}

.cal-week-time00 {
  text-align: right;
  border-right: solid 1px var(--calendar-border);
  border-left: solid 1px var(--calendar-border);
  padding: 1px 5px 2px;
}

.cal-week-hour00 > td.cal-week-cell,
.cal-week-time00 {
  border-top: solid 1px var(--calendar-border);
  border-bottom: dashed 1px var(--calendar-border);
}

.cal-week-hour30 > td.cal-week-cell,
.cal-week-time30 {
  border-bottom: solid 1px var(--calendar-border);
}

.cal-week-time30,
.cal-week-cell {
  border-right: solid 1px var(--calendar-border);
  border-left: solid 1px var(--calendar-border);
  height: 2.2em;
}

.cal-week-cell {
  position: relative;
}

.cal-week-cell > div {
  position: absolute;
  top: 0;
  z-index: 5;
  width: 100%;
}

.cal-week-today {
  background-color: var(--button-border-disabled);
}

.cal-week-add-item {
  display: none;
  margin: 0 1px 2px;
  padding: 0 4px 1px;
  position: absolute;
  top: 0;
  right: 0;
}

.cal-week-cell:hover .cal-week-add-item {
  display: block;
  cursor: pointer;
}
